import { map } from 'rxjs';
import { PAGINATION_ORDER } from '@core/constants/pagination.constant';
import { tanstackQueryService } from '@core/services/TanstackQuery.service';
import { FLOW_CHAT_ANSWER_STATUS, FLOW_CHAT_QUERY_KEYS } from '../constants/flowChat.constant';
import { abcloudzFlowChatService } from '../services/AbcloudzFlowChat.service';
import type { TGetChatHistoryRequest } from '../models/flowChat.model';

class AbcloudzFlowChatQuery {
  public getChatHistory$ = ({
    flowId,
    sessionId,
    offset,
    limit,
    // eslint-disable-next-line @typescript-eslint/no-useless-default-assignment
    order = PAGINATION_ORDER.DESC
  }: TGetChatHistoryRequest) =>
    tanstackQueryService
      .infiniteQuery({
        queryKey: [FLOW_CHAT_QUERY_KEYS.getHistory, flowId, sessionId],
        queryFn: ({ pageParam }) =>
          abcloudzFlowChatService.getChatHistory({
            flowId,
            sessionId,
            offset: pageParam,
            limit,
            order
          }),
        enabled: !!sessionId && !!flowId,
        initialPageParam: offset,
        getNextPageParam: (lastPage) =>
          lastPage.data.count >= lastPage.data.offset + lastPage.data.limit
            ? lastPage.data.offset + lastPage.data.limit
            : undefined
      })
      .pipe(
        map(({ data, ...rest }) => {
          if (data) {
            const messages = data.pages.flatMap((page) => page.data.messages);
            const answerStatus = data.pages.flatMap((page) => page.data.answerStatus);

            return {
              ...rest,
              data: { messages, answerStatus: answerStatus.at(-1) }
            };
          }

          return {
            ...rest,
            data: { messages: [], answerStatus: FLOW_CHAT_ANSWER_STATUS.completed }
          };
        })
      );
}

const abcloudzFlowChatQuery = new AbcloudzFlowChatQuery();

export { abcloudzFlowChatQuery };
